import React from 'react';
import { enqueueSnackbar, closeSnackbar } from 'notistack';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export const showNotification = (message, type = 'success') => {
    enqueueSnackbar(message || 'Server error, please try again later!', {
        variant: type, // Matches 'success', 'error', 'warning', 'info'
        autoHideDuration: 3000,
        anchorOrigin: {
            vertical: 'top',
            horizontal: 'right',
        },
        style: {
            maxWidth: '300px',
            whiteSpace: 'pre-line',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'flex-start',
            flexWrap: 'nowrap',
            wordBreak: 'break-word',
        },
        action: (key) => React.createElement(
            IconButton,
            {
                size: 'small',
                'aria-label': 'close',
                color: 'inherit',
                onClick: () => closeSnackbar(key),
                style: {
                    marginLeft: '8px',
                    flexShrink: 0,
                    marginTop: '-2px',
                },
            },
            React.createElement(CloseIcon, { fontSize: 'small' })
        ),
    });
};


